import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { AiTaskQueue, AiTaskQueueStatus, AiTaskQueueStatusArrayValues } from '../../helpers/schema';

export const schema = z.object({
  sessionId: z.string().min(1),
  status: z.enum(AiTaskQueueStatusArrayValues).optional(),
});

export type InputType = z.infer<typeof schema>;

export type QueueItemWithDetails = Selectable<AiTaskQueue> & {
  taskTitle: string;
  personaName: string;
  personaIcon: string;
  triggeredByName: string;
};

export type OutputType = {
  items: QueueItemWithDetails[];
};

export const listAiQueue = async (params: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(params);
  const searchParams = new URLSearchParams();
  searchParams.set('sessionId', validatedInput.sessionId);
  if (validatedInput.status) {
    searchParams.set('status', validatedInput.status);
  }
  const result = await fetch(`/_api/ai-queue/list?${searchParams.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
